/**
 * Päivän kysymys — enimmäispituus (lomake, API, mainospalkki).
 * Pidä synkassa: server/index.js (DAILY_QUESTION_MAX_LENGTH).
 */
export const DAILY_QUESTION_MAX_CHARS = 50;

export function truncateDailyQuestionForAdvert(text) {
  const s = String(text ?? '').trim();
  if (s.length <= DAILY_QUESTION_MAX_CHARS) return s;
  return `${s.slice(0, DAILY_QUESTION_MAX_CHARS)}...`;
}

/** Bucket for scaling type in the advert strip (0 = short … 3 = max length). */
export function dailyQuestionAdvertScaleBucket(rawQuestion) {
  const len = String(rawQuestion ?? '').trim().length;
  const capped = Math.min(len, DAILY_QUESTION_MAX_CHARS);
  if (capped > 42) return 3;
  if (capped > 30) return 2;
  if (capped > 17) return 1;
  return 0;
}
